import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, RefreshCw, UserCheck, BadgeCheck } from 'lucide-react';
export function HeroSection() {
  const whatsappUrl = 'https://wa.me/573182434499?text=Hola%20Gerfaj%2C%20vi%20su%20p%C3%A1gina%20de%20Reformas%20y%20quiero%20una%20asesor%C3%ADa%20para%20mi%20proyecto.';
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gerfaj-dark pt-28 pb-16" data-id="element-82">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-83">
        <img src="https://cdn.magicpatterns.com/uploads/maYmpyw9Tcf2G1p1fSdatM/GERFAJ-CONVENTO.jpg" alt="Convento Gerfaj" className="w-full h-full object-cover opacity-50" fetchPriority="high" loading="eager" decoding="async" width={2070} height={1380} data-id="element-84" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/60 to-gerfaj-dark" data-id="element-85"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 max-w-5xl" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-4xl" data-id="element-87">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full border border-gerfaj-orange/30 bg-gerfaj-orange/10 text-gerfaj-orange text-sm font-medium tracking-wide" data-id="element-88">
            Construcción · Reformas · Obra Civil
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-montserrat font-extrabold text-white leading-[1.1] mb-6 text-center" data-id="element-89">
            ¿Planeas construir desde cero o renovar tu espacio con la{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gerfaj-orange to-orange-400" data-id="element-90">
              tranquilidad
            </span>{' '}
            de que todo saldrá bien?
          </h1>

          <p className="text-lg md:text-xl text-gray-200 font-medium mb-8 max-w-2xl mx-auto leading-relaxed font-inter text-center" data-id="element-91">
            Transformamos tus ideas en realidades de alto valor. 30 años de
            experiencia en ejecución, garantizan que tu proyecto avance sin
            sorpresas ni retrasos.
          </p>

          <div className="mb-8 flex flex-col sm:flex-row sm:items-center justify-center gap-5 sm:gap-6 text-sm text-gray-200" data-id="element-92">
            <div className="flex items-center gap-2" data-id="element-93">
              <RefreshCw className="w-4 h-4 text-gerfaj-orange flex-shrink-0" data-id="element-94" />
              <span className="font-medium" data-id="element-95">
                Nos adaptamos a la fase en la que te encuentres
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-96">
              <UserCheck className="w-4 h-4 text-gerfaj-orange flex-shrink-0" data-id="element-97" />
              <span className="font-medium" data-id="element-98">
                Atención personalizada y directa
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-99">
              <BadgeCheck className="w-4 h-4 text-gerfaj-orange flex-shrink-0" data-id="element-100" />
              <span className="font-medium" data-id="element-101">
                Calidad garantizada en cada detalle
              </span>
            </div>
          </div>

          <div className="flex justify-center" data-id="element-102">
            <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex gap-3 bg-gerfaj-orange hover:bg-orange-600 text-white font-bold text-lg px-8 py-4 rounded-2xl cta-glow transition-colors duration-300 w-[90%] sm:w-auto min-h-[60px] items-center justify-center" data-id="element-103">
              <MessageCircle className="w-6 h-6" data-id="element-104" />
              Iniciar consulta por WhatsApp
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}